export { isNonEmptyString } from './isNonEmptyString';
export { isIosApp } from './stitchfixApp';
export { isLocal } from './isLocal';
export { getParams } from './getParams';
export { themeMapping } from './themeMapping';

// Cookies
export const REMEMBER_USER_COOKIE_NAME = 'remember_user_token' as const;
export const ACCEPT_INVITE_COOKIE_NAME = 'referral_redesign_title' as const;
export const DYNAMIC_ADS_COOKIE_NAME = 'dpa_grouping' as const;
export const HIGH_INTENT_COOKIE_NAME = 'intent_grouping' as const;

// Feature flags
export const IOS_APP_AUTH_COOKIE_OVERRIDE_FEATURE_FLAG_NAME =
  'client.web.auth_cookie_override_ios_app' as const;
export const FIX_RETURNS_IMPROVEMENTS_FEATURE_FLAG_NAME =
  'client.web.fix_checkout_returns_improvements' as const;
export const FREESTYLE_RETURNS_IMPROVEMENTS_FEATURE_FLAG_NAME =
  'client.web.freestyle_returns_improvements' as const;

export const KIDS_HOUSEHOLD_MIGRATION_FEATURE_FLAG_NAME =
  'client.household_kids_migration_enabled' as const;

// Fab experiments
export const HOUSEHOLD_PROFILES_CONFIG_PARAM_NAME =
  'eng.omniclient.household_profiles_buying_for_others' as const;
export const STYLEFILE_REFRESH_CONFIG_PARAM_NAME =
  'eng.kufak.stylefile_seasonal_refresh' as const;
export const HOUSEHOLD_UPSELL_CONFIG_PARAM_NAME =
  'cob.household_upsell' as const;
export const FASTLANE_ONBOARDING_CONFIG_PARAM_NAME =
  'eng.kufak.fastlane' as const;

// Max number of household profiles allowed per account, including the primary client
// Source: https://fixops-web.infra.int.stitchfix.com/apps/client-service/environment/production/environment_variables/MAX_HOUSEHOLD_MEMBER_COUNT
export const MAX_HOUSEHOLD_MEMBER_COUNT = 7;
